import { useWebSocket } from "../useWebSocket";
import { useElectronNotification } from "./useElectronNotification";

const channel = "NotificationChannel";

export const useNotificationWebSocket = (
  communityMemberId: number,
  onMessageReceive: (message: any) => void,
) => {
  const { sendNotificationToDesktopApp } = useElectronNotification();

  useWebSocket(
    {
      channel,
      onMessageReceive: (message: any) => {
        sendNotificationToDesktopApp({
          type: "notification",
          metadata: message?.data,
        });
        onMessageReceive(message);
      },
      community_member_id: communityMemberId,
      canCreateConnection: !!communityMemberId,
    },
    [communityMemberId],
  );
};
